import React from 'react';
import MuiTable from '@mui/material/Table';

const Table = (props) => <MuiTable {...props} />;

export default Table;
